<app-loading-placeholder [width]="'100%'" [height]="'20px'" [marginBottom]="'20px'">
</app-loading-placeholder>
<app-loading-placeholder [width]="'70%'" [height]="'20px'" [marginBottom]="'20px'">
</app-loading-placeholder>
<app-loading-placeholder [width]="'100%'" [height]="'20px'" [marginBottom]="'20px'">
</app-loading-placeholder>
<app-loading-placeholder [width]="'90%'" [height]="'20px'" [marginBottom]="'20px'">
</app-loading-placeholder>